import {
  Button, Col, Result, Row,
} from 'antd';
import cs from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { EmployerContext, UserContext } from 'contexts';
import { useEmployer } from 'hooks/useEmployer';
import PageTitle from '../../components/PageTitle';
import EmployerTitleSection from '../EmployerCreationPage/components/EmployerTitleSection';
import styles from '../EmployerCreationPage/EmployerCreation.module.scss';
import { ReactComponent as CircleDoneGreen } from '../../assets/icons/CircleDoneGreen.svg';
import LoadingIndicator from '../../components/LoadingIndicator';
import LoadingOverlay from '../../components/LoadingOverlay';

const CongratulationsPage = () => {
  const { user } = useContext(UserContext);
  const { employerData, employerResult } = useContext(EmployerContext);
  const { formatMessage } = useIntl();
  const location = useLocation();
  const pressedEmployerURI = location.state?.from === 'pressedEmployerCreation';
  const [isLoading, setLoading] = useState(false);

  const { isLoadingEmployer, getEmployer } = useEmployer({
    companyName: employerData?.companyName,
    country: employerData?.country,
    postalCode: employerData?.postalCode,
    clientWebSiteUrl: employerData?.clientWebSiteUrl,
    stateProvince: employerData?.stateProvince,
    streetAddress: employerData?.streetAddress,
    city: employerData?.city,
    industryKey: employerData?.industryKey,
  });

  // eslint-disable-next-line no-return-assign
  const handleGoToMain = () => window.location.href = 'https://joblio-prod.web.app/';

  const status = employerResult?.status;
  const isSuccess = true;

  const getUserUpdateSuccess = localStorage.getItem('userUpdateSuccess');

  useEffect(() => {
    if (pressedEmployerURI && employerData) {
      setLoading(true);
      if (user?.uid) {
        setLoading(isLoadingEmployer);
        if (!getUserUpdateSuccess) return;
        getEmployer();
        localStorage.removeItem('userUpdateSuccess');
      } else {
        setLoading(false);
      }
    }
  }, [user?.uid, location, getUserUpdateSuccess]);

  return (
    !isLoading || employerData ? (
      <>
        <PageTitle>
          <EmployerTitleSection />
        </PageTitle>
        <section>
          <div className="container container-medium">
            <div className={`${styles.EmployerContainer} form-holder`}>
              <div className={styles.EmployerBottom}>
                <Col>
                  <Result
                    icon={isSuccess ? <CircleDoneGreen /> : <LoadingIndicator />}
                    status={isSuccess ? 'success' : status}
                    className={styles.resultWrapper}
                    title={isSuccess && (
                      <span className={styles.resultTitle}>
                        {formatMessage({ id: 'employer.congratulations' })}
                      </span>
                    )}
                    extra={isSuccess ? (
                      <>
                        <p>{formatMessage({ id: 'employer.title.success' })}</p>
                        <Row
                          key="buttonResult"
                          align="middle"
                          className="text-left form-button-holder"
                        >
                          <Col span={24}>
                            <Button
                              type="primary"
                              className={cs(styles.resultButton, 'btn')}
                              onClick={handleGoToMain}
                            >
                              <FormattedMessage id="form.button.start_hiring" />
                            </Button>
                          </Col>
                        </Row>
                      </>
                    ) : null}
                  />
                </Col>
              </div>
            </div>
          </div>
        </section>
      </>
    ) : <LoadingOverlay isLoading />
  );
};

export default CongratulationsPage;
